import { SummaryMode } from './types'
import type { TimeSeriesDataPoint } from './types'

/**
 * Summarises a time series for the accessible summary / data-table caption.
 *
 * - `latest`: the period total for count metrics (SummaryMode.TOTAL), otherwise
 *   the last non-null value (default, for cumulative metrics like Followers).
 * - `change`: first→last delta for level metrics; null for Total metrics.
 *
 * Pure and dependency-light (types only).
 */
export function getTimeSeriesSummary(
  data: TimeSeriesDataPoint[],
  mode: SummaryMode = SummaryMode.LATEST,
): {
  latest: number | null
  change: number | null
} {
  const validPoints = data.filter(
    (p): p is TimeSeriesDataPoint & { value: number } => p.value != null,
  )

  if (validPoints.length === 0) return { latest: null, change: null }

  if (mode === SummaryMode.TOTAL) {
    const total = validPoints.reduce((sum, p) => sum + p.value, 0)
    return { latest: total, change: null }
  }

  const latest = validPoints[validPoints.length - 1].value
  const first = validPoints[0].value
  return { latest, change: latest - first }
}
